module.exports = __webpack_public_path__ + "static/media/PEUGEOT.865c421a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/agsm/img/carBrands/PEUGEOT.png
 ** module id = 1661
 ** module chunks = 0
 **/